import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider";
import { Role } from "../model/types";

export const ProtectedRoute = ({
  children,
  roles,
}: {
  children: ReactNode;
  roles?: Role[];
}) => {
  const { isAuthenticated, hasRole } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (roles && !hasRole(roles)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
